import PropTypes from 'prop-types';
import { BulkActionTypePropType } from '../../prop-types/bulk-action-type';
import { BulkUpdateModelPropType } from '../../prop-types/bulk-update-model';
import { BulkActionService } from '../../services/bulk-action-service';
import { BulkJobDataPropType } from '../../prop-types/bulk-job-data';
import { noop } from 'ui-components/default-props/noop';
import { emptyObject } from 'ui-components/default-props/empty';

const BulkAction = ({ bulkActionId, model = emptyObject, onChange = noop, jobData = emptyObject, isEmpty = false, onClose = noop }) => {
  return BulkActionService.getComponent(bulkActionId)(onChange, model, jobData, isEmpty, onClose);
};

BulkAction.propTypes = {
  bulkActionId: BulkActionTypePropType.isRequired,
  model: BulkUpdateModelPropType,
  onChange: PropTypes.func,
  jobData: BulkJobDataPropType,
  isEmpty: PropTypes.bool,
  onClose: PropTypes.func,
};

export default BulkAction;
